import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

import img1 from './assets/1.svg';
import img2 from './assets/2.svg';
import img3 from './assets/3.svg';
import img4 from './assets/4.svg';
import img5 from './assets/5.svg';
import img6 from './assets/6.svg';
import img7 from './assets/7.svg';
import img8 from './assets/8.svg';
import img9 from './assets/9.svg';
import img10 from './assets/10.svg';
import img11 from './assets/11.svg';
import img12 from './assets/12.svg';
import img13 from './assets/13.svg';
import img14 from './assets/14.svg';
import img15 from './assets/15.svg';
import img16 from './assets/16.svg';
import img17 from './assets/17.svg';
import img18 from './assets/18.svg';
import img19 from './assets/19.svg';

const svgImages = [
  img1, img2, img3, img4, img5, img6, img7, img8, img9,
  img10, img11, img12, img13, img14, img15, img16, img17, img18, img19
];

const slideVariants = {
  initial: { scale: 0.8, opacity: 0, rotate: -10, y: 20 },
  animate: { scale: 1, opacity: 1, rotate: 0, y: 0 },
  exit: { scale: 0.8, opacity: 0, rotate: 10, y: -20 },
};

export default function SVGSliderLoader() {
  const [index, setIndex] = useState(0);

  // Change slide every 5 seconds.
  useEffect(() => {
    const timer = setTimeout(() => {
      setIndex(prev => (prev + 1) % svgImages.length);
    }, 5000);
    return () => clearTimeout(timer);
  }, [index]);

  return (
    <div className="w-full h-full flex flex-col justify-center items-center mt-8">
      {/* Slide container */}
      <div className="relative w-full max-w-[600px] h-[250px] md:h-[350px] px-4 sm:px-0">
        <AnimatePresence exitBeforeEnter>
          <motion.img
            key={index}
            src={svgImages[index]}
            alt={`Slide ${index + 1}`}
            className="absolute inset-0 w-full h-full object-cover rounded-lg"
            variants={slideVariants}
            initial="initial"
            animate="animate"
            exit="exit"
            transition={{ duration: 1.5, ease: "easeInOut" }}
          />
        </AnimatePresence>
      </div>
      <div className="mt-10">
        <p className="text-lg font-medium">
          We are building your project, hold on tight...
        </p>
      </div>
      {/* Creative Loading Bar */}
      <div className="mt-8 w-full max-w-[600px] h-4 relative overflow-hidden rounded bg-gray-200">
        <motion.div
          className="h-full"
          initial={{ width: '0%' }}
          animate={{ width: '100%' }}
          transition={{ duration: 90, ease: 'linear' }}
          style={{
            background: 'linear-gradient(90deg, #007CF0, #00DFD8, #00F260)',
            backgroundSize: '200% 100%',
          }}
        >
          <motion.div
            className="h-full w-full"
            animate={{ backgroundPositionX: ['0%', '100%'] }}
            transition={{ duration: 2, repeat: Infinity, ease: 'linear' }}
          />
        </motion.div>
      </div>
    </div>
  );
}
